<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset variants-product-page">
        <v-col cols="12" class="pt-0">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-2">
                    <div>
                        <p class="pl-2 pl-xl-3">Attributi Prodotto</p>
                    </div>              
                    <div>
					    <p v-if="entityTitle" class="entity-title">&nbsp;&nbsp;{{ entityTitle }}</p>
				    </div>
                </v-card-title>
                <v-divider></v-divider>

                <v-container fluid class="py-2" :class="{'px-4': $vuetify.breakpoint.mdAndUp, 'px-3': $vuetify.breakpoint.smAndDown}">
                    <div class="d-flex align-center flex-wrap mb-2">
                        <span class="caption font-weight-medium text--secondary mr-2">Attributi selezionati:</span>
                        <v-chip v-for="(attribute, a) in attributes" x-small :key="a" class="mr-1 my-1">{{ attribute.name }}</v-chip>
                    </div>

                    <div v-for="(attribute, i) in attributes" :key="i" class="d-flex align-center flex-wrap py-1">
                        <span class="caption font-weight-medium mr-2" style="min-width: 90px;">{{ attribute.name }}</span>
                        <v-chip v-for="(option, o) in attribute.options" x-small :key="o" class="mr-1 my-1">{{ option.text }}</v-chip>
                    </div>
                </v-container>
            </v-card>
        </v-col>

        <v-col cols="12" class="pt-2">
            <v-card class="flex pa-0 round-card background-2">
                <v-card-title class="pa-3">
				    <p class="pl-2 pl-xl-3">Varianti</p>
                    <v-btn class="ml-1" icon text @click="showHelp = !showHelp">
                        <v-icon color="info">mdi-information-outline</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-text-field class="hidden-xs-only font-weight-regular"
                        append-icon="search"
                        label="Cerca"
                        v-model="search"
                        clearable
                        hide-details
                        outlined
                        dense
                    ></v-text-field>
                    <v-btn class="mr-1" icon text @click.stop="expand = !expand">
                        <v-icon>{{ expand ? 'expand_less' : 'expand_more' }}</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>

                <v-alert
                    v-model="showHelp"
                    dismissible
                    dense
                    text
                    type="info"
                    icon="mdi-information-outline"
                    class="ma-3 mb-0 body-2"
                    @input="onHelpDismissed">
                    Le modifiche (aggiungi, modifica, elimina, combinazioni, prezzi) restano <strong>locali</strong>:
                    premi <strong>Aggiorna</strong> (in basso a destra) per salvarle sul server.
                    La generazione barcode richiede varianti già salvate.
                </v-alert>

                <!-- Striscia di copertura: UN posto solo dove leggere lo stato foto.
                     Le varianti create in blocco nascono senza foto — il buco deve
                     essere visibile subito, non scoprirsi sul telefono di un cliente.
                     Quando e' tutto a posto la striscia CONFERMA invece di sparire. -->
                <v-alert
                    dense
                    text
                    :type="coverageOk ? 'success' : 'warning'"
                    :icon="coverageOk ? 'mdi-check-circle-outline' : 'mdi-image-off-outline'"
                    class="ma-3 mb-0 body-2 coverage-strip">
                    <!-- Il testo vive in un elemento SUO con colore diretto: il
                         `warning--text` che il type mette sul root colora per
                         eredità, e un colore diretto sul figlio vince sempre —
                         la guerra di specificità con l'utility Vuetify è persa
                         in partenza (stesso peso, decide l'ordine dei CSS). -->
                    <span class="coverage-strip-text">
                        <span v-if="models.length">
                            <a v-if="uncoveredCount" class="font-weight-medium" @click="openCoveragePanel">{{ uncoveredCount }} {{ uncoveredCount === 1 ? 'variante senza foto' : 'varianti senza foto' }}</a>
                            <span v-else>Tutte le varianti hanno una foto</span>
                            <span class="mx-1">·</span>
                        </span>
                        <a v-if="!hasCover" class="font-weight-medium" @click="openCoveragePanel">manca la copertina del prodotto</a>
                        <span v-else>copertina impostata</span>
                    </span>
                    <!-- L'auto-match risolve il problema in un colpo per chi ha i file
                         nominati bene: sta QUI, accanto allo stato, non sepolto nel
                         pannello a fisarmonica dei prezzi. -->
                    <v-btn
                        v-if="photos.length && uncoveredCount"
                        small
                        text
                        color="primary"
                        class="ml-2"
                        @click="autoMatchOpen = true"
                    >Assegna foto automaticamente</v-btn>
                </v-alert>

                <v-container class="pa-0" fluid>
                    <v-slide-y-transition>
                        <v-card class="pt-4 background-2" elevation="0" v-show="expand">
                            <v-row class="ma-0 pl-6">
                                <div class="body-2">Inserisci l'importo da incrementare a tutti i prezzi della varianti selezionate</div>
                            </v-row>
                            <v-row class="ma-0 pl-4">
                                <v-col lg="3" cols="12">
                                    <v-text-field
                                        label="Importo"
                                        type="number"
                                        clearable
                                        v-model="increment"
                                        outlined
                                        dense>
                                        <v-btn text icon color="success" slot="append-outer">
                                            <v-tooltip top>
            									<template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" @click="incrementPrice">playlist_add</v-icon>
            									</template>
                                                <span>Incrementa</span>
                                            </v-tooltip>
                                        </v-btn>
                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-row class="ma-0 pl-6">
                                <div class="body-2">Inserisci l'importo percentuale da incrementare a tutti i prezzi della varianti selezionate</div>
                            </v-row>
                            <v-row class="ma-0 pl-4">
                                <v-col lg="3" cols="12">
                                    <v-text-field
                                        label="Importo %"
                                        type="number"
                                        suffix="%"
                                        clearable
                                        v-model="incrementPerc"
                                        outlined
                                        dense>
                                        <v-btn text icon color="success" slot="append-outer">
                                            <v-tooltip top>
            									<template v-slot:activator="{ on }">
                                                    <v-icon v-on="on" @click="incrementPricePerc()">playlist_add</v-icon>
            									</template>
                                                <span>Incrementa in %</span>
                                            </v-tooltip>
                                        </v-btn>

                                    </v-text-field>
                                </v-col>
                            </v-row>
                            <v-card-actions class="pt-0">
                                <v-spacer></v-spacer>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" text color="primary" @click="toggleAll">{{ selected.length ? 'Deseleziona tutti' : 'Seleziona tutti' }}</v-btn>
                                    </template>
                                    <span>Seleziona o deseleziona tutte le varianti</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on"><v-btn text color="red" :disabled="!selected.length" @click="confirmDelete = true">Elimina</v-btn></span>
                                    </template>
                                    <span>Rimuove le varianti selezionate dalla tabella (locale, salva con Aggiorna)</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <span v-on="on"><v-btn text color="primary" :disabled="!selected.length" @click="openBarcodeDialog(selected)">Genera Barcode</v-btn></span>
                                    </template>
                                    <span>Genera barcode per le selezionate (richiede varianti già salvate)</span>
                                </v-tooltip>
                                <v-tooltip top v-if="$store.getters.checkSettings('variants_regenerate_code')">
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" text color="info" :loading="loadingSyncCombinations" @click="confirmSyncCombinations = true">Aggiorna combinazioni</v-btn>
                                    </template>
                                    <span>Aggiunge le combinazioni mancanti e completa le varianti esistenti, senza rimuoverne nessuna (locali, salva con Aggiorna)</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn v-on="on" text color="info" :loading="loadingGenerateCombinations" @click="confirmCreateCombinations = true">Crea tutte le combinazioni</v-btn>
                                    </template>
                                    <span>Genera tutte le combinazioni degli attributi e le aggiunge in tabella (locali, salva con Aggiorna)</span>
                                </v-tooltip>
                            </v-card-actions>
                        <v-divider></v-divider>
                        </v-card>
                    </v-slide-y-transition>
                    <v-progress-linear v-show="loading" height="2" class="my-0" :indeterminate="loading"></v-progress-linear>

                    <v-container class="py-0" fluid>
                        <v-row class="ma-0">
                            <v-col cols="12" class="hidden-sm-and-up pa-3">
                                <v-text-field 
                                    append-icon="search"
                                    label="Cerca"
                                    v-model="search"
                                    clearable
                                    hide-details
                                    outlined
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>

                    <v-data-table v-if="loaded"
                        :options.sync="pagination"
                        :items="models"
                        :headers="headers"
                        :search="search"
                        v-model="selected"
                        :mobile-breakpoint="0"
                        show-select
                        class="background-2 enhanced-table"
                        :footer-props="{
                            'items-per-page-options': [10, 25, 50,  { text: 'Tutti', value: -1 }],
                            showFirstLastPage: true
                        }">

                        <template v-slot:header.data-table-select="{ on, props }">
                            <v-simple-checkbox color="primary" v-bind="props" v-on="on"></v-simple-checkbox>
                        </template>

			            <template v-slot:item="props">
                            <tr>
                                <td>
                                    <v-simple-checkbox color="primary" :value="props.isSelected" @input="props.select($event)"></v-simple-checkbox>
                                </td>
                                <td class="px-2" style="width: 40px; font-size: 14px !important; font-weight: 500; text-align: center;">
                                    {{ props.index + 1 + pagination.itemsPerPage * ( pagination.page - 1 ) }}
                                </td>
                                <td style="width: 130px; white-space: nowrap;">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon class="mx-0" @click.stop="editVariant(props.item.id)">
                                                <v-icon color="teal">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Modifica la variante (locale, salva con Aggiorna)</span>
                                    </v-tooltip>
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on }">
                                            <v-btn v-on="on" icon class="mx-0" @click.stop="deleteItem(props.index)">
                                                <v-icon color="pink">delete</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Rimuove la variante dalla tabella (locale, salva con Aggiorna)</span>
                                    </v-tooltip>
                                    <v-tooltip top v-if="!props.item.barcode && props.item.id > 0">
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon class="mx-0" v-on="on" @click.stop="openBarcodeDialog([props.item])">
                                                <v-icon color="primary">mdi-barcode</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Genera barcode (variante già salvata)</span>
                                    </v-tooltip>
                                </td>
                                <td>
                                    <v-text-field v-if="editIndex == props.item.id"
                                        type=text
                                        label='Codice Variante'
                                        v-model="props.item['code']"
                                        :error-messages="errors.collect('code'+props.item.id)"
                                        v-validate="formatValidate(props)"
                                        :data-vv-name="'code'+props.item.id"
                                        data-vv-as="code"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                    <span v-else>
                                            {{ props.item['code'] }}
                                    </span>
                                </td>
                                <td>
                                    <v-text-field v-if="editIndex == props.item.id"
                                        type=text
                                        label='SKU'
                                        v-model="props.item['sku']"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                    <span v-else>
                                            {{ props.item['sku'] }}
                                    </span>
                                </td>
                                <td>
                                    <v-text-field v-if="editIndex == props.item.id"
                                        type=text
                                        label='Nome Variante'
                                        v-model="props.item['name']"
                                        :error-messages="errors.collect('Nome'+props.item.id)"
                                        v-validate="'required'"
                                        :data-vv-name="'Nome'+props.item.id"
                                        data-vv-as="Nome"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                    <span v-else>
                                            {{ props.item['name'] }}
                                    </span>
                                </td>
                                <!-- Foto della variante (legame esplicito in pivot: prima foto
                                     che la reclama, fallback copertina). Il click sulla thumb apre
                                     l'anteprima; la matita apre il pannello di assegnazione con
                                     questa variante gia' spuntata. -->
                                <td style="width: 96px;">
                                    <div class="d-flex align-center">
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <div
                                                    v-on="on"
                                                    class="variant-photo-cell"
                                                    :class="{'variant-photo-cell--clickable': coverFor(props.item)}"
                                                    @click.stop="openPhotoPreview(props.item)"
                                                >
                                                    <img
                                                        v-if="coverFor(props.item)"
                                                        :src="coverFor(props.item)"
                                                        class="variant-photo-thumb"
                                                        alt="Foto variante"
                                                    >
                                                    <div v-else class="variant-photo-thumb variant-photo-thumb--empty">
                                                        <v-icon small color="grey lighten-1">image</v-icon>
                                                    </div>
                                                    <span v-if="photoCountFor(props.item) > 1" class="variant-photo-count">{{ photoCountFor(props.item) }}</span>
                                                </div>
                                            </template>
                                            <span>{{ photoCellTooltip(props.item) }}</span>
                                        </v-tooltip>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on }">
                                                <v-btn icon small class="ml-1" v-on="on" @click.stop="openAssignPanel(props.item)">
                                                    <v-icon small color="teal">mdi-image-edit-outline</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Assegna foto a questa variante</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                                <td v-for="(attribute, i) in attributes" :key="'attribute'+i" style="max-width: 200px">
                                    <v-autocomplete v-if="editIndex == props.item.id"
                                        :items="attribute.options"
                                        :label="attribute.name"
                                        v-model="props.item['attributes'][attribute.id]['values']"
                                        small-chips
                                        deletable-chips
                                        return-object
                                        item-text="text"
                                        item-value="value"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-autocomplete>
                                    <span v-else>
                                        {{ props.item['attributes'][attribute.id]['values'] ? props.item['attributes'][attribute.id]['values']['text'] : '' }}
                                    </span>
                                </td>
                                
                                <td style="max-width: 100px;">
                                    <v-text-field v-if="editIndex == props.item.id"
                                        type="number"
                                        label='Prezzo'
                                        v-model.number="props.item['price']"
                                        :error-messages="errors.collect('Prezzo'+props.item.id)"
                                        v-validate="'required'"
                                        :data-vv-name="'Prezzo'+props.item.id"
                                        data-vv-as="Prezzo"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                    <span v-else>
                                        {{ props.item['price'] | currency}}
                                    </span>
                                </td>
                                <td style="max-width: 100px;">
                                    <v-text-field v-if="editIndex == props.item.id"
                                        type="text"
                                        label='Barcode'
                                        v-model="props.item['barcode']"
                                        dense
                                        outlined
                                        hide-details="auto"
                                    ></v-text-field>
                                    <span v-else>
                                        {{ props.item['barcode'] }}
                                    </span>
                                </td>              
                                <td style="max-width: 100px;">
                                    <v-switch v-if="editIndex == props.item.id"
                                        class="ma-0 pa-0"
                                        inset
                                        dense
                                        hide-details
                                        v-model="props.item['barred']"
                                        color="primary"
                                    ></v-switch>                                    
                                    <span v-else>
                                        {{ props.item['barred'] ? 'Si' : 'No' }}
                                    </span>
                                </td>
                            </tr>
                        </template>

                        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
                            <div class="warning--text"><span class="warning--text">{{ selected.length }}</span> Selezionati</div>
                            Da {{ pageStart }} a {{ pageStop }} di {{ itemsLength }}
                        </template>
                    </v-data-table>                            

                </v-container>
                <v-card-text style="position: relative">
                    <v-tooltip top>
                        <template v-slot:activator="{ on }">
                            <v-fab-transition>
                                <v-btn
                                    v-on="on"
                                    @click.native="addVariant()"
                                    color="primary"
                                    small
                                    dark
                                    absolute
                                    bottom
                                    left
                                    fab>
                                    <v-icon>add</v-icon>
                                </v-btn>
                            </v-fab-transition>
                        </template>
                        <span>Aggiunge una variante vuota (locale, salva con Aggiorna)</span>
                    </v-tooltip>
                </v-card-text>
            </v-card>
        </v-col>
        <v-tooltip top>
            <template v-slot:activator="{ on: tooltip }"> 
                <v-fab-transition>
                    <v-btn
						v-on="{ ...tooltip }"
                        @click.native="updateModel()"
                        :loading="saved"
                        color="primary"
                        dark
                        fixed
                        bottom
                        right
                        fab>
                        <v-icon>sync</v-icon>
                    </v-btn>
                </v-fab-transition>
            </template>
            <span>Aggiorna: salva tutte le modifiche sul server</span>
        </v-tooltip>
        <confirm-dialog 
			:confirmModel.sync="confirmDelete"
			mainTitle="Eliminare gli elementi selezionati?"
			secondTitle="Gli elementi selezionati verranno eliminati, per salvare l'eliminazione ricordati di premere Aggiorna"
			:atConfirm="deleteSelected"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>
        <confirm-dialog
			:confirmModel.sync="confirmCreateCombinations"
			mainTitle="Generare tutte le combinazioni?"
			secondTitle="Le combinazioni vengono aggiunte alla tabella ma non ancora salvate: premi Aggiorna per salvarle. Possono crearsi duplicati con le varianti esistenti; se non li vuoi, elimina prima quelle esistenti."
			:atConfirm="generateCombinations"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>
        <confirm-dialog
			:confirmModel.sync="confirmSyncCombinations"
			mainTitle="Allineare le varianti agli attributi attuali?"
			secondTitle="Aggiunge le combinazioni mancanti e completa le varianti esistenti, senza rimuoverne nessuna. Ricalcola i codici dal codice del padre: è lo SKU, può creare doppioni sullo shop alla prossima sync. Modifiche locali: premi Aggiorna per salvarle."
			:atConfirm="syncCombinations"
			:confirm="{label:'Procedi', color:'info'}"
		></confirm-dialog>
        <confirm-dialog
			:confirmModel.sync="blockedVariantsDialog"
			mainTitle="Alcune varianti non sono state eliminate"
			:secondTitle="blockedVariantsMessage"
			:cancel="{label:'Ho capito', color:'primary'}"
		></confirm-dialog>

        <v-dialog v-model="barcodeDialog" max-width="600" persistent>
            <v-card class="background-2 round-card">
                <v-card-title class="pa-3">
                    <p class="pl-2 pl-xl-3">Generazione Barcode</p>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text class="pt-4 body-2">Vuoi generare i barcode per le varianti selezionate?</v-card-text>
                <v-card-text class="body-2">Varianti coinvolte: <span class="body-1 font-weight-medium">{{ barcodeTargets.length }}</span></v-card-text>

                <v-row class="mx-0 px-4">
                    <v-col>
                        <p class="pb-2">Seleziona il prefisso da utilizzare:</p>
                        <v-select
                            v-model="selectedPrefix"
                            :items="barcodePrefixes"
                            outlined
                            dense
                            label="Prefisso"
                            :menu-props="{'offset-y': true}"
                            :disabled="loadingBarcode"
                            :error-messages="prefixError"
                            @input="prefixError = ''"
                        ></v-select>

                        <v-checkbox
                            v-model="replaceExisting"
                            label="Sostituisci i barcode esistenti"
                            color="primary"
                            hide-details
                            class="mt-2"
                        ></v-checkbox>
                    </v-col>
                </v-row>

                <v-row class="mx-0 px-4 pb-6">
                    <v-col class="pt-0">
                        <small>
                            <p><strong>Informazioni:</strong></p>
                            <ul>
                                <li>Verrà generato un barcode univoco per ogni variante coinvolta</li>
                                <li>I barcode saranno nel formato EAN-13 con il prefisso scelto</li>
                                <li v-if="replaceExisting">I barcode esistenti verranno sovrascritti</li>
                                <li v-else>Le varianti che hanno già un barcode verranno saltate</li>
                                <li>Il barcode viene salvato immediatamente sulla variante</li>
                            </ul>
                        </small>
                    </v-col>
                </v-row>

                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="info" :disabled="loadingBarcode" @click="barcodeDialog = false">Annulla</v-btn>
                    <v-btn text color="primary" :loading="loadingBarcode" @click="generateBarcodes()">Procedi</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <photo-variant-assign-panel
            v-model="panelOpen"
            :product-id="id"
            :preset-variant-id="panelVariantId"
            @saved="loadPhotos"
            @cover-changed="loadPhotos"
        ></photo-variant-assign-panel>

        <photo-variant-auto-match-dialog
            v-model="autoMatchOpen"
            :photos="photos"
            :variants="models"
            :attributes="attributes"
            @applied="loadPhotos"
            @failed="loadPhotos"
        ></photo-variant-auto-match-dialog>

        <file-preview-dialog
            v-model="previewOpen"
            :items="previewItems"
        ></file-preview-dialog>

    </v-row>
</template>

<script>
    import Vue from 'vue'
    import PhotoVariantAssignPanel from '@/components/modules/products/PhotoVariantAssignPanel'
    import PhotoVariantAutoMatchDialog from '@/components/modules/products/PhotoVariantAutoMatchDialog'
    import FilePreviewDialog from '@/components/common/FilePreviewDialog'
    import { isImageExt } from '@/components/utilities/imageFiles'
    import capacitorService from '@/services/capacitor-service'

    export default {
        name: 'variants-product',
        components: {
            PhotoVariantAssignPanel,
            PhotoVariantAutoMatchDialog,
            FilePreviewDialog
        },
        props: {
            id: Number,
            entityTitle: String
        },

        data() {
            return {
                saved: false,
                showDial: true,
                showHelp: true,
                attributes: [],            
                models: [],
                loaded: false,
                expand: false,
                increment: 0,
                incrementPerc: 0,
                selected: [],
                dummyId: 0,
                editIndex: null,
                pagination: {},
                search: '',
                loading: false,
                confirmDelete: false,
                confirmCreateCombinations: false,
                loadingGenerateCombinations: false,
                confirmSyncCombinations: false,
                loadingSyncCombinations: false,
                blockedVariantsDialog: false,
                blockedVariantsMessage: '',
                modelDefs: 'products',
                barcodeDialog: false,
                barcodeTargets: [],
                selectedPrefix: null,
                prefixError: '',
                replaceExisting: false,
                loadingBarcode: false,
                photos: [],
                // ObjectURL delle anteprime create in questa istanza, da revocare
                previewUrls: [],
                panelOpen: false,
                panelVariantId: null,
                autoMatchOpen: false,
                previewOpen: false,
                previewItems: [],
            }
        },

        computed: {
            barcodePrefixes() {
                return this.$store.getters.getSetting('barcode_prefixes') || []
            },

            selectedId() {
                return this.selected.map((item) => {
                    return item.id
                }) 
            },

            totalItems() {
                return this.models.length
            },

            /**
             * Varianti (righe locali incluse: una riga non salvata e' comunque
             * senza foto) che nessuna foto reclama in `variant_ids`
             */
            uncoveredCount() {
                const covered = {}
                this.photos.forEach((photo) => {
                    (photo.variant_ids || []).forEach((id) => { covered[id] = true })
                })
                return this.models.filter((model) => !covered[model.id]).length
            },

            hasCover() {
                return this.photos.some((photo) => photo.is_cover)
            },

            coverageOk() {
                return this.hasCover && (!this.models.length || !this.uncoveredCount)
            },

            /**
             * Foto per riga: {variant_id: photo}. Prima foto (per id) che
             * reclama la variante in `variant_ids` — NESSUN fallback alla
             * copertina: la colonna mostra il LEGAME, e deve concordare coi
             * chip del File Storage ("non associata") e con la striscia di
             * copertura. Il ripiego sulla copertina lo fa l'app al render.
             */
            photoByVariantId() {
                const map = {}

                this.models.forEach((model) => {
                    let best = null
                    this.photos.forEach((photo) => {
                        if((photo.variant_ids || []).indexOf(model.id) === -1) return
                        if(!best || photo.id < best.id) best = photo
                    })
                    map[model.id] = best
                })

                return map
            },

            headers() {
                let headers = [{'text': '#', value: 'number', sortable: false}, {'text': 'Azioni', value: 'actions', sortable: false}, {'text': 'Codice', value:'code', sortable: true}, {'text': 'SKU', value: 'sku', sortable: true}, {'text': 'Nome', value: 'name', sortable: true}]
                headers.push({'text': 'Foto', value: 'photo', sortable: false})
                this.attributes.map((attribute) => {
                    return headers.push({'text': attribute.name, value: 'attribute_'+attribute.id, sortable: true})
                })
                headers.push({'text': 'Prezzo', value: 'price', sortable: true})
                headers.push({'text': 'Barcode', value: 'barcode', sortable: true})
                headers.push({'text': 'Disabilitato', value: 'barred', sortable: true})
                return headers
            }
        },

        created() {
            this.showHelp = localStorage.getItem('variants_help_dismissed') !== '1'
            this.axios.get('products/' + this.id + '/attributes').then(response => {
                // get body data
                
                this.attributes = response.data.attributes.map((attr) => {
                    attr.options = attr.values
                    return attr
                })
                this.loadPhotos()

                this.$store.commit('endProgress')
                setTimeout(() => { this.showDial = false }, this.$store.getters.dialTimeout);

                this.initializeVariants()

            }, response => {
                    // error callback
            })
        },

        beforeDestroy() {
            this.previewUrls.forEach((url) => {
                try { URL.revokeObjectURL(url) } catch (e) { /* gia' revocato */ }
            })
            this.previewUrls = []
        },

        methods: {

            onHelpDismissed(value) {
                if(!value) localStorage.setItem('variants_help_dismissed', '1')
            },

            loadPhotos() {
                return this.axios.post('attachmentslists/', {attachable_type: 'product', id: this.id}).then((response) => {
                    const all = Array.isArray(response.data.attachments) ? response.data.attachments : []
                    this.photos = all.filter((a) => isImageExt(a.ext))
                    this.loadMissingThumbnails()
                }, () => {
                    this.photos = []
                })
            },

            /**
             * Input:  nessuno (lavora su `this.photos`)
             * Fa:     anteprima autenticata per le sole foto senza thumbnail.
             *         Su build nativa non parte: il ramo `preview` di `getFile`
             *         finisce in `saveCapacitorFile` → `FileOpener.open`, cioe' una
             *         apertura di file con l'app di sistema per OGNI foto, e per
             *         giunta risolve `null` (nessuna miniatura da mostrare).
             * Output: nessuno — gli ObjectURL creati finiscono in `previewUrls`,
             *         che `beforeDestroy` revoca (altrimenti perdono a ogni load)
             */
            loadMissingThumbnails() {
                if(capacitorService.isNative) return
                this.photos.forEach((photo) => {
                    if(photo.thumbnail || !photo.path) return
                    this.$eventBusUtility.getFile(this.$store, '/files/' + photo.path, photo.name, true)
                        .then((url) => {
                            if(!url) return
                            this.previewUrls.push(url)
                            Vue.set(photo, '_previewUrl', url)
                        })
                        .catch(() => {})
                })
            },

            previewSrc(photo) {
                if(!photo) return null
                if(photo.thumbnail) return 'data:image/jpeg;base64,' + photo.thumbnail
                return photo._previewUrl || null
            },

            coverPhotoFor(variant) {
                return variant ? (this.photoByVariantId[variant.id] || null) : null
            },

            // Quante foto reclamano la variante (pivot n-n): la cella mostra la
            // principale, il badge dice che ce ne sono altre.
            photoCountFor(variant) {
                if (!variant) return 0
                return this.photos.filter((photo) => (photo.variant_ids || []).indexOf(variant.id) !== -1).length
            },

            photoCellTooltip(variant) {
                const count = this.photoCountFor(variant)
                if (!count) return 'Nessuna foto per questa variante'
                if (count === 1) return 'Apri l\'anteprima'
                return 'Apri l\'anteprima — ' + count + ' foto assegnate'
            },

            coverFor(variant) {
                return this.previewSrc(this.coverPhotoFor(variant))
            },

            // La miniatura in tabella e' minuscola: il click la apre a schermo intero
            // col visualizzatore gia' usato dal File Storage (blob autenticato).
            // TUTTE le foto che reclamano la variante (pivot n-n), navigabili con
            // le frecce: la cella mostra la principale, la preview le fa scorrere.
            openPhotoPreview(variant) {
                if(!variant) return
                const claiming = this.photos
                    .filter((photo) => (photo.variant_ids || []).indexOf(variant.id) !== -1)
                    .sort((a, b) => a.id - b.id)
                if(!claiming.length) return
                this.previewItems = claiming.map((photo) => ({
                    doc: photo,
                    url: 'dms/product/' + this.id + '/documents/' + photo.id + '/download'
                }))
                this.previewOpen = true
            },

            /**
             * Input:  riga della tabella
             * Fa:     apre il pannello di assegnazione con questa variante gia'
             *         spuntata. Le righe locali non ancora salvate (id dummy
             *         negativo) non possono ricevere assegnazioni: id fantasma.
             */
            openAssignPanel(variant) {
                if(!variant || !(variant.id > 0)) {
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: 'Variante non ancora salvata: premi Aggiorna prima di assegnarle una foto',
                        value: true,
                        color: 'warning'
                    })
                    return
                }
                this.panelVariantId = variant.id
                this.panelOpen = true
            },

            // Dalla striscia di copertura: pannello senza variante pre-spuntata
            // (si parte dalla scelta della foto, dove si elegge anche la copertina)
            openCoveragePanel() {
                this.panelVariantId = null
                this.panelOpen = true
            },

            formatValidate(props) {
                if(props.item.barred) {
                    return 'required'
                } else return ('required|server:product,unique,code,' + props.item.id)
            },

            initializeVariants() {
                this.loading = true 
                this.axios.get('products/' + this.id + '/variants/edit').then(response => {
                    // get body data
                    this.models = response.data.model

                    _.forEach(this.models, (model, m) => {
                        if(this.models[m].attributes.length == 0) {
                            this.models[m].attributes = {}
                        }
                        let model_attribute_ids = []
                        _.forEach(model.attributes, (at) => {
                            let values = at.values
                            Vue.set(at, 'values', values)
                            model_attribute_ids.push(at.id)
                        })
                        let needed_attribute_ids = this.attributes.map((a) => { return a['id'] })
                        _.forEach(needed_attribute_ids, (id_value) => {
                            if(!model_attribute_ids.includes(id_value)) {
                                Vue.set(this.models[m]['attributes'], [id_value], {'values': []})
                            }
                        })
                    })
                    
                    this.loaded = true
                    this.loading = false
                }, response => {
                        // error callback
                });
            },

            toggleAll() {
                if (this.selected.length) {
                    this.selected = []   
                } else { 
                    this.selected = this.models.slice()
                }        
            },

            editVariant(index) {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    if(this.editIndex == index) {
                        this.editIndex = 0
                    } else {
                        this.editIndex = index
                    }
                }).catch(() => {

                })
            },

            deleteSelected() {
                this.models = this.models.filter((item) => {
                    return !this.selectedId.includes(item.id)
                })
                this.confirmDelete = false
            },

            /**
             * Input:  combo (oggetto-variante dal BE), attributes map della riga
             * Fa:     riempie gli attributi correnti mancanti e assegna un id dummy negativo
             * Output: lo stesso combo, pronto per la tabella
             */
            prepareCombo(combo) {
                if(!combo.attributes) combo.attributes = {}
                this.attributes.forEach((attribute) => {
                    if(!combo.attributes[attribute.id]) Vue.set(combo.attributes, attribute.id, {'values': []})
                })
                combo.id = this.dummyId--
                return combo
            },

            /**
             * Input:  un valore di attributo (oggetto {text,value}, stringa legacy, o [] = vuoto)
             * Output: string normalizzata per il confronto, null se il valore non c'è
             */
            attributeValueKey(value) {
                if(value === null || value === undefined || Array.isArray(value)) return null
                const raw = typeof value === 'object'
                    ? (value.value !== null && value.value !== undefined && value.value !== '' ? value.value : value.text)
                    : value
                if(raw === null || raw === undefined || raw === '') return null
                return String(raw).trim().toLowerCase()
            },

            generateCombinations() {
                this.loadingGenerateCombinations = true
                this.axios.get('products/' + this.id + '/variants-combinations').then(response => {

                    // Le combinazioni arrivano dal BE come oggetti (non salvate):
                    // le inseriamo nella tabella come righe nuove (id dummy negativo),
                    // verranno persistite solo col bottone Salva.
                    const combos = response.data.models || []
                    combos.forEach((combo) => this.prepareCombo(combo))
                    // Unshift in blocco: preserva l'ordine del BE (= ordine dei valori enum
                    // digitati), che al Salva diventa ordine di creazione DB e quindi ordine
                    // varianti su Shopify. L'unshift per-item lo invertiva (LIFO).
                    this.models.unshift(...combos)

                    this.loadingGenerateCombinations = false
                }, response => {
                    // error callback
                    this.loadingGenerateCombinations = false
                });
            },

            /**
             * Allinea la tabella varianti alle combinazioni degli attributi ATTUALI del padre.
             * Caso d'uso: e' stato aggiunto un attributo al prodotto (o un suo valore) e le
             * varianti esistenti vanno estese senza rifarle da capo. Le combinazioni arrivano
             * dal BE (stesso endpoint di "Crea tutte"); il diff gira qui perche' deve operare
             * sullo stato LOCALE della tabella (righe non ancora salvate comprese).
             *  - variante incompleta (attributo aggiunto dopo) -> completata sulla prima
             *    combinazione libera compatibile, cosi' conserva id, giacenza, barcode e prezzo
             *  - combinazione senza variante -> aggiunta come riga nuova (id dummy negativo)
             *  - righe agganciate: pivot degli attributi non piu' dichiarati scartati (update()
             *    li cancella perche' non arrivano piu' nel payload) e code ricalcolato dal padre
             * NON rimuove NIENTE: le righe che non corrispondono a nessuna combinazione (valore
             * non piu' previsto, doppioni) restano in coda alla tabella e le elimina l'utente col
             * cestino, che e' l'unica via di cancellazione. Tutto locale: persistenza col Salva.
             */
            syncCombinations() {
                if(!this.attributes.length) {
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        value: true,
                        color: 'warning',
                        text: 'Il prodotto non ha attributi con valori: aggiungili nel tab Attributi prima di aggiornare le combinazioni'
                    })
                    return
                }

                this.loadingSyncCombinations = true
                this.axios.get('products/' + this.id + '/variants-combinations').then(response => {

                    const combos = response.data.models || []
                    if(!combos.length) {
                        // Guardia: senza combinazioni valide un allineamento svuoterebbe la tabella.
                        this.$store.commit('setSnackbar', {
                            timeout: 6000,
                            value: true,
                            color: 'warning',
                            text: 'Nessuna combinazione calcolabile dagli attributi del prodotto: varianti lasciate invariate'
                        })
                        this.loadingSyncCombinations = false
                        return
                    }

                    // Il ricalcolo del code resta governato dalla sua setting (il bottone oggi
                    // e' gia' gated da questa, ma le due cose restano indipendenti).
                    const regenerateCode = this.$store.getters.checkSettings('variants_regenerate_code')

                    // Righe che possono rappresentare una combinazione: servono almeno un valore
                    // (una riga vuota non identifica niente e verrebbe agganciata a caso).
                    const candidates = []
                    this.models.forEach((model) => {
                        const values = {}
                        let filled = 0
                        this.attributes.forEach((attribute) => {
                            const entry = model.attributes ? model.attributes[attribute.id] : null
                            const key = this.attributeValueKey(entry ? entry.values : null)
                            values[attribute.id] = key
                            if(key !== null) filled++
                        })
                        if(filled) candidates.push({model: model, values: values, filled: filled})
                    })

                    // Le righe complete prendono la loro combinazione; quelle parziali (valori
                    // mancanti perche' un attributo e' stato aggiunto dopo) vengono COMPLETATE
                    // sulla prima combinazione libera compatibile, cosi' la variante conserva
                    // id, giacenza, barcode e prezzo invece di essere rifatta da capo.
                    candidates.sort((a, b) => b.filled - a.filled)
                    const claimed = {}
                    const taken = new Set()
                    candidates.forEach((candidate) => {
                        const index = _.findIndex(combos, (combo, i) => {
                            if(claimed[i]) return false
                            return this.attributes.every((attribute) => {
                                const value = candidate.values[attribute.id]
                                if(value === null) return true
                                const entry = combo.attributes ? combo.attributes[attribute.id] : null
                                return this.attributeValueKey(entry ? entry.values : null) === value
                            })
                        })
                        // Nessuna combinazione libera compatibile (valore non piu' previsto o
                        // doppione): la riga non viene agganciata, ma nemmeno tolta.
                        if(index === -1) return
                        claimed[index] = candidate
                        taken.add(candidate.model)
                    })

                    let added = 0
                    let updated = 0
                    let unchanged = 0
                    const models = []
                    combos.forEach((combo, i) => {
                        const candidate = claimed[i]
                        if(!candidate) {
                            models.push(this.prepareCombo(combo))
                            added++
                            return
                        }

                        const model = candidate.model
                        let touched = candidate.filled < this.attributes.length
                        // Gli attributi della combinazione sostituiscono quelli della riga: i
                        // valori coincidono dove c'erano, i mancanti vengono valorizzati e i
                        // pivot degli attributi non piu' dichiarati spariscono dal payload
                        // (update() li cancella a DB).
                        Vue.set(model, 'attributes', combo.attributes)

                        if(regenerateCode && combo.code && model.code !== combo.code) {
                            Vue.set(model, 'code', combo.code)
                            touched = true
                        }
                        if(touched) updated++
                        else unchanged++
                        models.push(model)
                    })

                    // Le righe non agganciate restano in coda, nell'ordine in cui erano: e'
                    // l'utente a decidere se eliminarle col cestino.
                    const leftovers = this.models.filter((model) => !taken.has(model))

                    this.models = models.concat(leftovers)
                    this.selected = []
                    this.editIndex = null
                    Vue.set(this.pagination, 'page', 1)

                    const changed = added + updated
                    let text = changed > 0
                        ? 'Combinazioni allineate: ' + added + ' aggiunte, ' + updated + ' aggiornate, ' + unchanged + ' invariate — premi Aggiorna per salvare'
                        : 'Combinazioni gia\' allineate agli attributi attuali: nessuna modifica'
                    if(leftovers.length) {
                        text += '. ' + leftovers.length + ' varianti non allineate lasciate in fondo alla tabella: eliminale col cestino se non servono'
                    }

                    this.$store.commit('setSnackbar', {
                        timeout: 8000,
                        value: true,
                        color: changed > 0 ? 'success' : 'info',
                        text: text
                    })

                    this.loadingSyncCombinations = false
                }, response => {
                    // error callback
                    this.loadingSyncCombinations = false
                });
            },

            incrementPrice() {
                if(!this.increment ) {
                    this.increment = this.increment ? this.increment : 0
                } else {
                    this.selected.map((item) => {
                        item.price = item.price ? item.price : 0
                        item.price = parseFloat(item.price) + parseFloat(this.increment)
                    })
                    this.increment = 0
                }
            },

            incrementPricePerc() {
                if(!this.incrementPerc ) {
                    this.incrementPerc = this.incrementPerc ? this.incrementPerc : 0
                } else {
                    this.selected.map((item) => {
                        item.price = item.price ? item.price : 0
                        if(this.incrementPerc != 0)
                            item.price = parseFloat(item.price) + (parseFloat(item.price) * this.incrementPerc) / 100
                    })
                    this.incrementPerc = 0
                }
            },

            deleteItem(index) {
                this.models.splice(index + this.pagination.itemsPerPage * ( this.pagination.page - 1 ), 1)
            },

            updateModel() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    this.saved = true
                    this.axios.put('products/' + this.id + '/variants', {'variants': this.models}).then(response => {
                        // get body data

                        this.saved = false

                        const blocked = response.data.blocked || []
                        if(blocked.length > 0) {
                            // Il backend non le ha cancellate (varianti movimentate): il
                            // client le aveva gia' tolte da this.models col cestino, vanno
                            // ripristinate ricaricando dal server per non disallinearsi dal DB.
                            const relationLabels = {
                                quotations: 'preventivi', saleorders: 'ordini di vendita', purchaseorders: 'ordini di acquisto',
                                ddts: 'DDT', purchaseddts: 'DDT di acquisto', documents: 'documenti', tasks: 'attività',
                                assets: 'asset', interventions: 'interventi', subscriptions: 'abbonamenti',
                            }
                            const lines = blocked.map(b => {
                                const relText = Object.keys(b.relations || {}).map(k => `${b.relations[k]} ${relationLabels[k] || k}`).join(', ')
                                return `${b.name || b.code || ('#' + b.id)} (usata in: ${relText})`
                            })
                            this.blockedVariantsMessage = 'Non è possibile eliminarle perché già movimentate: ' + lines.join(' — ')
                            this.blockedVariantsDialog = true
                            this.initializeVariants()
                            return
                        }

                        // Got in show
                        this.$eventBusUtility.chooseRedirect(this.$router, response, this.redirect, this.modelDefs)
                    }, response => {
                        // error callback
                    });
                }).catch(() => {

                })
            },

            addVariant() {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return false
                    }

                    let defaultObject = {'attributes': {}, 'id': this.dummyId, 'price': 0, 'barred': false}
                    let needed_attribute_ids = this.attributes.map((a) => { return a['id'] })
                    _.forEach(needed_attribute_ids, (id_value) => {
                        Vue.set(defaultObject.attributes, [id_value], {'values': []})
                    })
                    this.models.unshift(defaultObject)
                    this.editIndex = this.dummyId--
                    Vue.set(this.pagination,'page', 1)

                }).catch(() => {

                })

            },

            openBarcodeDialog(items) {
                this.barcodeTargets = items.filter(item => item && item.id > 0)
                if (!this.barcodeTargets.length) {
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: 'Nessuna variante salvata da elaborare. Premi Aggiorna prima di generare il barcode.',
                        value: true,
                        color: 'warning'
                    })
                    return
                }
                this.selectedPrefix = null
                this.prefixError = ''
                this.replaceExisting = false
                this.barcodeDialog = true
            },

            generateBarcodes() {
                if (!this.selectedPrefix) {
                    this.prefixError = 'Seleziona un prefisso per procedere'
                    return
                }

                const candidates = this.replaceExisting
                    ? this.barcodeTargets
                    : this.barcodeTargets.filter(item => !item.barcode)

                if (!candidates.length) {
                    this.barcodeDialog = false
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: 'Tutte le varianti selezionate hanno già un barcode',
                        value: true,
                        color: 'info'
                    })
                    return
                }

                this.loadingBarcode = true
                this.axios.post('products-generate-barcode/', {
                    ids: candidates.map(item => item.id),
                    prefix: this.selectedPrefix,
                    replace_existing: this.replaceExisting,
                }).then(response => {
                    response.data.data.forEach((bc, k) => {
                        Vue.set(candidates[k], 'barcode', bc)
                    })
                    this.loadingBarcode = false
                    this.barcodeDialog = false
                    this.$store.commit('setSnackbar', {
                        timeout: 6000,
                        text: `Generati ${candidates.length} barcode`,
                        value: true,
                        color: 'success'
                    })
                }, () => {
                    this.loadingBarcode = false
                    this.$store.commit('setSnackbarError')
                })
            }
        },

    }
</script>

<style>
.variants-product-page .variant-photo-cell {
    display: inline-flex;
    position: relative;
}
.variants-product-page .variant-photo-cell--clickable {
    cursor: zoom-in;
}
.variants-product-page .variant-photo-thumb {
    width: 44px;
    height: 44px;
    object-fit: cover;
    border-radius: 4px;
    background: #f3f4f6;
}
.variants-product-page .variant-photo-thumb--empty {
    display: flex;
    align-items: center;
    justify-content: center;
}
/* Striscia di copertura: testo a colore pieno del tema, non colorato come il
   tipo dell'alert — arancio-su-arancio (e verde-su-verde) non si leggeva.
   L'icona resta colorata dal type: è lei a portare lo stato. Le regole
   colpiscono DIRETTAMENTE gli elementi del testo (span + a), non il root:
   il colore diretto vince sull'ereditato di `warning--text` senza dipendere
   dall'ordine dei fogli di stile. */
.variants-product-page .coverage-strip .coverage-strip-text,
.variants-product-page .coverage-strip .coverage-strip-text span,
.variants-product-page .coverage-strip .coverage-strip-text a {
    color: rgba(0, 0, 0, 0.87) !important;
}
.theme--dark .variants-product-page .coverage-strip .coverage-strip-text,
.theme--dark .variants-product-page .coverage-strip .coverage-strip-text span,
.theme--dark .variants-product-page .coverage-strip .coverage-strip-text a {
    color: rgba(255, 255, 255, 0.87) !important;
}
.variants-product-page .coverage-strip .coverage-strip-text a {
    text-decoration: underline;
}
/* Badge conteggio: la variante ha PIU' foto assegnate (pivot n-n), la cella
   mostra solo la principale. */
.variants-product-page .variant-photo-count {
    position: absolute;
    right: -4px;
    bottom: -4px;
    min-width: 16px;
    height: 16px;
    padding: 0 4px;
    border-radius: 8px;
    background: #1976d2;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
}

/* In dark mode allinea il bg dell'enhanced-table al background-2 del card contenitore.
   Selettori più specifici delle regole sticky in table-enhancements.css per vincere il !important.
   Limitato alla pagina varianti via .variants-product-page così non impatta Crud e altre pagine. */
.theme--dark .variants-product-page .enhanced-table thead th,
.theme--dark .variants-product-page .enhanced-table.v-data-table thead th:first-child,
.theme--dark .variants-product-page .enhanced-table.v-data-table thead th:nth-child(2),
.theme--dark .variants-product-page .enhanced-table td:first-child,
.theme--dark .variants-product-page .enhanced-table td:nth-child(2) {
    background-color: #424242 !important;
}
</style>
